import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AvatarPlaceholder',
  props: {
    backgroundColor: { default: '#fff' },
    color: { default: '#8c7328' },
    size: { default: '20' }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})